import { Layout, Text, Card, Tag, Button } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import openDockLogo from '../../assets/opendock-logo.png'
import { MissingDate } from './MissingDate'

type AppointmentCardEmptyStateProps = {
  onButtonClick: () => void
  isOpenDockFacility?: boolean
  disabled?: boolean
}

export function AppointmentCardEmptyState({
  onButtonClick,
  isOpenDockFacility,
  disabled,
}: AppointmentCardEmptyStateProps) {
  function handleOpenSchedule(action: string) {
    onButtonClick()
  }

  return (
    <Layout.Stack>
      <Text variant="heading-sm-bold">Schedule appointment</Text>
      <Card flagged flag-color="color-danger-20">
        <Card.Body>
          <Layout.Group justify="space-between" align="center">
            <Layout.Group align="center">
              <Icon name="clock" width={22} height={22} />
              <Layout.Stack gap="spacing-1">
                <Tag variant="danger" size="small" style={{ display: 'block' }}>
                  Scheduling required
                </Tag>
                <MissingDate />
              </Layout.Stack>
            </Layout.Group>
            <Layout.Stack align="flex-end">
              {isOpenDockFacility && <img src={openDockLogo} alt="OpenDock" width={105} />}
              <Layout.Group>
                <Button
                  type="button"
                  variant="primary"
                  size="small"
                  onClick={() => handleOpenSchedule('selfschedule')}
                  disabled={disabled}
                >
                  Schedule
                </Button>
              </Layout.Group>
            </Layout.Stack>
          </Layout.Group>
        </Card.Body>
      </Card>
    </Layout.Stack>
  )
}
